import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { DomSelectors, DomSelectorsSite, DomSelectorsPage } from './domSelectors'
import { DomSelectorsSymbol } from './symbols'

// Re-export pure helpers from thunderbolt-commons for convenience
export {
	getByCompId,
	getClosestByCompId,
	getElementCompId,
	querySelector,
	querySelectorAll,
	convertIdSelectorToClassSelector,
} from '@wix/thunderbolt-commons'

export type { DualModeSelectorOptions } from '@wix/thunderbolt-commons'

// Export feature for IoC contexts
export { DomSelectors, DomSelectorsSite, DomSelectorsPage } from './domSelectors'
export { DomSelectorsSymbol } from './symbols'
export type { IDomSelectors, DomSelectorsPageConfig } from './types'

// Site-level binding (with CARMI site config containing component IDs)
export const site: ContainerModuleLoader = (bind) => {
	bind(DomSelectorsSymbol).to(DomSelectorsSite)
}

// Page-level binding (with CARMI config containing component IDs)
export const page: ContainerModuleLoader = (bind) => {
	bind(DomSelectorsSymbol).to(DomSelectorsPage)
}

// Editor binding is in src/ds/index.ts to avoid pulling DS dependencies into viewer bundle
